import { countryCode } from '../shared/countries';

const dateFmt = new Intl.DateTimeFormat('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' });

/** "3 jan 2026" */
export function formatDate(iso: string): string {
  return dateFmt.format(new Date(iso)).replace('.', '');
}

export const sizeLabel = (ml: number) => `${ml} ml`;

/** "NL · 500" */
export const shortMeta = (country: string, ml: number) => `${countryCode(country)} · ${ml}`;

/** "US · 710 ml", "US" or "710 ml" for a zoeklijst line; null when any variant will do. */
export function wantedMeta(want: { country: string | null; sizeMl: number | null }): string | null {
  const parts = [want.country && countryCode(want.country), want.sizeMl && sizeLabel(want.sizeMl)].filter(Boolean);
  return parts.length ? parts.join(' · ') : null;
}

export const imageUrl = (id: string) => `/api/images/${id}`;
